import React, { useState } from 'react';
import { GuestType } from '../contexts/GuestContext';
import './PasswordGate.scss';

interface PasswordGateProps {
  onPasswordSuccess: (type: GuestType) => void;
}

// Set your passwords here
const PASSWORDS = {
  weekend: 'AutumnLeaves',
  farmhouse: 'TwilightPrincess',
};

export const PasswordGate: React.FC<PasswordGateProps> = ({ onPasswordSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [colorTheme] = useState(() => Math.random() > 0.5 ? 'bluegreen' : 'darkred');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simulate a small delay for better UX
    setTimeout(() => {
      const trimmedPassword = password.trim().replace(/\s/g, '').toLowerCase();

      if (trimmedPassword === PASSWORDS.weekend.toLowerCase()) {
        onPasswordSuccess('weekend');
      } else if (trimmedPassword === PASSWORDS.farmhouse.toLowerCase()) {
        onPasswordSuccess('farmhouse');
      } else {
        setError('Incorrect password. Please check your invitation for the correct password.');
        setPassword('');
        setIsLoading(false);
      }
    }, 500);
  };

  return (
    <div className="password-gate">
      <div className={`password-gate__overlay ${colorTheme}`} />
      <div className="password-gate__content">
        <div className="password-gate__card">
          <h1 className="password-gate__title">Erin & Luka</h1>
          <p className="password-gate__subtitle">
            Join the quest
          </p>
          <p>Please enter the password from your invitation to continue</p>
          <form onSubmit={handleSubmit} className="password-gate__form">
            <div className="password-gate__input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value.replace(/\s/g, ''))}
                placeholder="Enter your password (no spaces)"
                className="password-gate__input"
                disabled={isLoading}
                autoFocus
              />
              <div
                onClick={() => setShowPassword(!showPassword)}
                className="password-gate__toggle"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setShowPassword(!showPassword);
                  }
                }}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </div>
            </div>
            <span className="password-gate__visibility-hint">
              {showPassword ? 'Password visible' : 'Password hidden'}
            </span>

            {error && (
              <div className="password-gate__error">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading || !password.trim()}
              className="password-gate__button"
            >
              {isLoading ? 'Checking...' : 'Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
